import './CertificateCard.scss';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import download from 'downloadjs';
import { saveAs } from 'file-saver';
import moment from 'moment';

import Button from 'components/form/Button';
import Modal from 'components/Layout/Modal';
import CertificatePreview from '../CertificatePreview';
import VerifyOtpModel from 'pages/Common/RequestRaisedAndReceived/Common/VerifyOtpModel';

import { certificatePath, icons, newUserCertificate } from 'utils/constants';
import {
  downloadFile,
  generatePreSignedUrl,
  getCertificateData,
  getCertificatePdf,
  getDataFromLocalStorage,
  objectToFormData,
  titleCaseString,
  urlToUnitArray,
  checkEmailVerification,
  VERIFICATION_STEPS,
} from 'utils/helpers';

import {
  downloadCustomCertificate,
  handleRegenerateCertificate,
  handleSendCertificateDownloadOtp,
  setIsPremiumPopup,
  showSuccess,
  throwError,
  throwSuccess,
} from 'store/slices';
import { useNavigate } from 'react-router-dom';
import CertificateOtpPopup from '../CertificateOtpPopup';

const CertificateCard = ({
  ocmCategory,
  access,
  elem,
  index,
  loadingIndexes,
  getProfiles,
}) => {
  const {
    title,
    img,
    user_type,
    certificate_number,
    isAwardWinner,
    event_name,
    event_type,
    filed_data,
    event_id,
    certificate_id,
    abstract_id,
    certificate_status,
    table_id,
    expire_at,
    certificate_log_id
  } = elem;

  const dispatch = useDispatch();
  const user_id = getDataFromLocalStorage('id');

  const [viewSample, setViewSample] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpDialog, setShowOtpDialog] = useState(false);
  const [otpVerification, setOtpVerification] = useState(false);
  const [otpId, setOtpId] = useState('');
  const [loadingButtons, setLoadingButtons] = useState([]);

  const isEmptyFieldData = filed_data === '';
  const urlType = img?.split('.').pop();
  const navigate = useNavigate();

  const handleView = async (data) => {
    try {
      if (!data) {
        dispatch(throwError({ message: 'Missing certificate data.' }));
        return;
      }
      if (data?.filed_data === '') {
        const certificateKey = data?.certificate_file;
        if (!certificateKey) {
          dispatch(throwError({ message: 'Missing certificate file key.' }));
          return;
        }
        const s3File = await generatePreSignedUrl(
          certificateKey,
          newUserCertificate
        );
        setViewSample(`${s3File}`);
      } else {
        const certificateData = getCertificateData(data?.filed_data, {
          certificate_number: data?.certificate_number || '',
          paper_title: data?.paper_title || '',
          create_at: data?.create_at || '',
        });

        const pdfFileData = await urlToUnitArray(data?.s3File);
        const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        setViewSample(blobUrl);
      }
    } catch (err) {
      console.error('Error in handleView:', err);
      dispatch(
        throwError({
          message: 'Something went wrong while previewing the certificate.',
        })
      );
    }
  };

  // const sendOtpRequest = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await dispatch(handleSendCertificateDownloadOtp());
  //     setShowOtpDialog(true);
  //     if (response.status === 200) {
  //       dispatch(showSuccess(response.message));
  //       setOtpId(response?.data?.otp_id);
  //     }
  //   } catch (error) {
  //     dispatch(throwError({ message: 'Failed to process request' }));
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleApproveRequest = async () => {
    // await sendOtpRequest();
    setShowOtpDialog(true);
  };

  const handleDownload = async (data) => {
    const certificateData = getCertificateData(data?.filed_data, {
      certificate_number: data?.certificate_number || '',
      paper_title: data?.paper_title || '',
      create_at: data?.create_at || '',
    });
    const pdfFileData = await urlToUnitArray(data.s3File);
    const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
    download(pdfBytes, data.img, 'application/pdf');
  };

  const downloadMyNewCertificate = async (data) => {
    const response = await dispatch(
      downloadCustomCertificate(objectToFormData(data))
    );
    if (response?.status === 200) {
      setShowOtpDialog(false);
      getProfiles();
      const certificateUrl = response?.data;
      const s3URL = await generatePreSignedUrl(
        certificateUrl,
        newUserCertificate
      );
      const responseCer = await axios.get(s3URL, { responseType: 'blob' });
      const blob = new Blob([responseCer?.data], {
        type: responseCer?.data?.type,
      });
      saveAs(blob, 'certificate.pdf');
      dispatch(throwSuccess(response?.message));
    }
  };

  const handleVerifyOtp = async (otp, otp_id) => {
    try {
      setOtpVerification(true);
      const payload = {
        event_id,
        id: certificate_id,
        user_id: user_id,
        abstract_id,
        otp_id: otp_id,
        otp,
        table_id,
        certificate_log_id: certificate_log_id ?? null
      };
      await downloadMyNewCertificate(payload);
      setOtpVerification(false);
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setOtpVerification(false);
    }
  };

  const handleCertificateRegenerate = async (elem) => {
    const payload = {
      certificate_log_id: elem.certificate_log_id,
      type: 1,
    };
    const response = await dispatch(handleRegenerateCertificate(payload));
    if (response?.status === 200) {
      getProfiles();
      dispatch(throwSuccess(response?.message));
    }
  };

  const handleDirectDownload = async (data) => {
    try {
      const certificatePath = data?.certificate_file;
      const s3URL = await generatePreSignedUrl(
        certificatePath,
        newUserCertificate
      );
      const responseCer = await axios.get(s3URL, {
        responseType: 'blob',
      });
      const blob = new Blob([responseCer?.data], {
        type: responseCer?.data?.type,
      });
      saveAs(blob, certificatePath);
    } catch (error) {
      dispatch(throwError({ message: 'S3 Token Error' }));
    }
  };

  const handleCertificateStatusAction = async (status, data) => {
    try {
      if (status === '2') {
        await handleCertificateRegenerate(data);
      } else if (status === '0') {
        await handleApproveRequest();
      } else {
        await handleDirectDownload(data);
      }
    } catch (err) {
      console.error('Error in certificate status action:', err);
    }
  };

  return (
    <>
      <div id="certificate-card-container">
        <div className="certificate-card">
          <div className="card-img-container">
            <CertificatePreview
              access={access}
              elem={elem}
              index={index}
              loadingIndexes={loadingIndexes}
            />
          </div>

          <div className="card-details">
            <div
              className="text-14-400-24 color-1717 event-title"
              title={title ? title : titleCaseString(event_name)}
            >
              {title ? title : titleCaseString(event_name)}
            </div>

            <div className="text-14-500-18 color-6866 cmt-16 ">
              <span>Certificate No :</span>
              <span> {certificate_number || '-'}</span>
            </div>

            {ocmCategory && (
              <div className="text-14-300-18 color-black-olive cmt-16">
                {ocmCategory}
              </div>
            )}

            {user_type === '1' && (
              <div className="text-14-300-18 color-black-olive cmt-16">
                Participation
              </div>
            )}
            {user_type === '3' && (
              <div className="text-14-300-18 color-black-olive cmt-16">
                Keynote Speakers
              </div>
            )}
            {user_type === '5' && (
              <div className="text-14-300-18 color-black-olive cmt-16">
                Session Speakers
              </div>
            )}
            {user_type === '4' && (
              <div className="text-14-300-18 color-black-olive cmt-16">
                Research Paper Presentation
              </div>
            )}

            {isAwardWinner && (
              <div className="text-12-400 color-title-navy cmt-16">
                Award winner
              </div>
            )}

            <div
              className={`text-12-400-15 ${certificate_status === '2' ? 'color-4646 ' : ''
                } cmt-14`}
            >
              <span className="cme-5">
                <img src={icons?.circleInfo} height={16} width={16} />
              </span>
              {isEmptyFieldData
                ? certificate_status === '2'
                  ? 'Your certificate validation has been expired'
                  : certificate_status === '0'
                    ? 'Generate certificate to download your certificate'
                    : `Certificate valid till ${moment(expire_at).format(
                      'DD-MMM-YYYY'
                    )}`
                : 'Download your certificate'}
            </div>

            <div className="d-flex gap-3 cmt-13">
              <Button
                text={
                  isEmptyFieldData
                    ? certificate_status === '2'
                      ? 'Re-Generate Certificate'
                      : certificate_status === '0'
                        ? 'Generate Certificate'
                        : 'Download Certificate'
                    : 'Download Certificate'
                }
                btnStyle="primary-dark"
                className="cps-10 cpe-10 h-35 text-nowrap me-2"
                btnLoading={loadingButtons?.includes(`cert-${index}`)}
                disabled={loadingButtons?.includes(`cert-${index}`)}
                onClick={async () => {
                  if (
                    !checkEmailVerification(
                      dispatch,
                      navigate,
                      VERIFICATION_STEPS.FULL_PROFILE
                    )
                  )
                    return;
                  setLoadingButtons((prev) => [...prev, `cert-${index}`]);
                  try {
                    if (access?.isUpgradeButton && event_type === 2) {
                      dispatch(setIsPremiumPopup(true));
                    } else if (urlType === 'pdf') {
                      if (isEmptyFieldData) {
                        await handleCertificateStatusAction(
                          certificate_status,
                          elem
                        );
                      } else {
                        await handleDownload(elem);
                      }
                    } else {
                      await dispatch(downloadFile(elem.img));
                    }
                  } catch (error) {
                    console.error('Error downloading certificate:', error);
                  } finally {
                    setLoadingButtons((prev) =>
                      prev.filter((btnKey) => btnKey !== `cert-${index}`)
                    );
                  }
                }}
              />


              {!isAwardWinner &&
                <Button
                  text={<i class="bi bi-bootstrap-reboot"></i>}
                  btnStyle="primary-dark"
                  className="cps-10 cpe-10 h-35 text-nowrap me-2"
                  btnLoading={loadingButtons?.includes(`regen-${index}`)}
                  disabled={loadingButtons?.includes(`regen-${index}`)}
                  onClick={async () => {
                    if (
                      !checkEmailVerification(
                        dispatch,
                        navigate,
                        VERIFICATION_STEPS.FULL_PROFILE
                      )
                    )
                      return;
                    setLoadingButtons((prev) => [...prev, `regen-${index}`]);
                    await handleApproveRequest();
                    setLoadingButtons((prev) =>
                      prev.filter((btnKey) => btnKey !== `regen-${index}`)
                    );
                  }}
                />}

              {(certificate_status === '1' || !isEmptyFieldData) && (
                <Button
                  btnStyle="primary-light-outline"
                  icon={<img src={icons.blueEyeIcon} alt="" />}
                  className="cps-10 cpe-10 h-35"
                  onClick={() => handleView(elem)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {viewSample && (
        <Modal fullscreen largeClose onHide={() => setViewSample('')}>
          <iframe
            frameBorder="0"
            src={`${viewSample}#toolbar=0&navpanes=0`}
            title="Certificate Preview"
            style={{ width: '100%', height: '99%' }}
          />
        </Modal>
      )}

      {showOtpDialog && <CertificateOtpPopup
        onHide={() => setShowOtpDialog(false)}
        handleVerifyOtp={handleVerifyOtp}
        otpVerification={otpVerification} />}
    </>
  );
};

export default CertificateCard;

{
  /* <VerifyOtpModel
          title="Certificate Download"
          showApproveDialog={showOtpDialog}
          onHide={() => setShowOtpDialog(false)}
          onVerify={handleVerifyOtp}
          sendOtpRequest={sendOtpRequest}
          otpVerification={otpVerification}
        /> */
}
